// Module
var code = "<md-button class=\"btnDefault\" ng-click=\"viewLicence()\">List Licences</md-button>\n";
// Exports
module.exports = code;